import * as React from 'react';
import * as CheckboxPrimitive from '@radix-ui/react-checkbox';
import { Check, Minus } from 'lucide-react';

import { cn } from '@/lib/utils';

function Checkbox({ className, checked, onCheckedChange, ...props }) {
  return (
    <CheckboxPrimitive.Root
      // IMPORTANT: Explicitly pass checked state to Radix
      checked={checked}
      onCheckedChange={onCheckedChange}
      className={cn(
        'peer size-4 shrink-0 rounded-[4px] border border-primary shadow-xs transition-shadow outline-none focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50',
        // Styles for BOTH checked and indeterminate states
        'data-[state=checked]:bg-primary data-[state=checked]:text-white',
        'data-[state=indeterminate]:bg-primary data-[state=indeterminate]:text-white',
        className
      )}
      {...props}
    >
      <CheckboxPrimitive.Indicator className="flex items-center justify-center text-current">
        {/* Radix only shows the Indicator if state is NOT 'unchecked' */}
        {checked === 'indeterminate' ? (
          <Minus className="size-3.5" strokeWidth={4} />
        ) : (
          <Check className="size-3.5" strokeWidth={4} />
        )}
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  );
}

export { Checkbox };
